import {Badge} from "react-bootstrap";
import React from "react";

export default function ShopStatusTableCell({ id, className, children, rowData }) {

    return (
        <td key={id} className={`border px-4 py-2${className ? " " + className : ""}`}>
            {rowData.is_order_withdrawn
                ? <Badge bg="danger">Widerrufen</Badge>
                : children}
        </td>
    );
}
